var render, staticRenderFns
import script from "./AuthLoginPage.vue?vue&type=script&lang=js"
export * from "./AuthLoginPage.vue?vue&type=script&lang=js"
import style0 from "./AuthLoginPage.vue?vue&type=style&index=0&id=f8c6f2fc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports